<template>
  <div class="pt-5">
    <v-data-table
      dense
      ref="myTable"
      :headers="headers"
      :items="impacts"
      :hide-default-footer="true"
      class="mb-5"
    >
      <template v-slot:item.OVERALL="props">
        <v-edit-dialog
          :return-value.sync="props.item.OVERALL"
          large
          persistent
          :disabled="true"
        >
          <div>{{ props.item.OVERALL }}</div>
          <template v-slot:input>
            <v-text-field
              v-model="props.item.OVERALL"
              :rules="[range]"
              label="Edit"
              single-line
              autofocus
              @input="handleInput(props.item, 'OVERALL')"
              type="number"
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.HEATING="props">
        <v-edit-dialog
          :return-value.sync="props.item.HEATING"
          large
          persistent
          :disabled="true"
        >
          <div>{{ props.item.HEATING }}</div>
          <template v-slot:input>
            <v-text-field
              v-model="props.item.HEATING"
              :rules="[range]"
              label="Edit"
              single-line
              counter
              autofocus
              @input="handleInput(props.item, 'HEATING')"
              type="number"
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.DOMESTIC_HOT_WATER="props">
        <v-edit-dialog
          :return-value.sync="props.item.DOMESTIC_HOT_WATER"
          large
          persistent
        >
          <div
            :class="{
              'zero-weights': [
                'COMFORT',
                'HEALTH_WELL_BEING_AND_ACCESSIBILITY',
              ].includes(props.item.name),
            }"
          >
            {{ props.item.DOMESTIC_HOT_WATER }}
          </div>
          <template v-slot:input>
            <v-text-field
              v-model="props.item.DOMESTIC_HOT_WATER"
              :rules="[range]"
              label="Edit"
              single-line
              counter
              autofocus
              @input="handleInput(props.item, 'DOMESTIC_HOT_WATER')"
              type="number"
              :readonly="
                ['COMFORT', 'HEALTH_WELL_BEING_AND_ACCESSIBILITY'].includes(
                  props.item.name
                )
              "
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.COOLING="props">
        <v-edit-dialog :return-value.sync="props.item.COOLING" large persistent>
          <div>{{ props.item.COOLING }}</div>
          <template v-slot:input>
            <v-text-field
              v-model="props.item.COOLING"
              :rules="[range]"
              label="Edit"
              single-line
              counter
              autofocus
              @input="handleInput(props.item, 'COOLING')"
              type="number"
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.VENTILATION="props">
        <v-edit-dialog
          :return-value.sync="props.item.VENTILATION"
          large
          persistent
        >
          <div
            :class="{
              'zero-weights': ['ENERGY_FLEXIBILITY_AND_STORAGE'].includes(
                props.item.name
              ),
            }"
          >
            {{ props.item.VENTILATION }}
          </div>
          <template v-slot:input>
            <v-text-field
              v-model="props.item.VENTILATION"
              :rules="[range]"
              label="Edit"
              single-line
              counter
              autofocus
              @input="handleInput(props.item, 'VENTILATION')"
              type="number"
              :readonly="
                ['ENERGY_FLEXIBILITY_AND_STORAGE'].includes(props.item.name)
              "
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.LIGHTING="props">
        <v-edit-dialog
          :return-value.sync="props.item.LIGHTING"
          large
          persistent
        >
          <div
            :class="{
              'zero-weights': [
                'ENERGY_FLEXIBILITY_AND_STORAGE',
                'HEALTH_WELL_BEING_AND_ACCESSIBILITY',
                'MAINTENANCE_AND_FAULT_PREDICTION',
                'INFORMATION_TO_OCCUPANTS',
              ].includes(props.item.name),
            }"
          >
            {{ props.item.LIGHTING }}
          </div>
          <template v-slot:input>
            <v-text-field
              v-model="props.item.LIGHTING"
              :rules="[range]"
              label="Edit"
              single-line
              counter
              autofocus
              @input="handleInput(props.item, 'LIGHTING')"
              type="number"
              :readonly="
                [
                  'ENERGY_FLEXIBILITY_AND_STORAGE',
                  'HEALTH_WELL_BEING_AND_ACCESSIBILITY',
                  'MAINTENANCE_AND_FAULT_PREDICTION',
                  'INFORMATION_TO_OCCUPANTS',
                ].includes(props.item.name)
              "
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.ELECTRICITY="props">
        <v-edit-dialog
          :return-value.sync="props.item.ELECTRICITY"
          large
          persistent
        >
          <div
            :class="{
              'zero-weights': [
                'COMFORT',
                'HEALTH_WELL_BEING_AND_ACCESSIBILITY',
              ].includes(props.item.name),
            }"
          >
            {{ props.item.ELECTRICITY }}
          </div>
          <template v-slot:input>
            <v-text-field
              v-model="props.item.ELECTRICITY"
              :rules="[range]"
              label="Edit"
              single-line
              counter
              autofocus
              @input="handleInput(props.item, 'ELECTRICITY')"
              type="number"
              :readonly="
                ['COMFORT', 'HEALTH_WELL_BEING_AND_ACCESSIBILITY'].includes(
                  props.item.name
                )
              "
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.DYNAMIC_BUILDING_ENVELOPE="props">
        <v-edit-dialog
          :return-value.sync="props.item.DYNAMIC_BUILDING_ENVELOPE"
          large
          persistent
        >
          <div
            :class="{
              'zero-weights': ['ENERGY_FLEXIBILITY_AND_STORAGE'].includes(
                props.item.name
              ),
            }"
          >
            {{ props.item.DYNAMIC_BUILDING_ENVELOPE }}
          </div>
          <template v-slot:input>
            <v-text-field
              v-model="props.item.DYNAMIC_BUILDING_ENVELOPE"
              :rules="[range]"
              label="Edit"
              single-line
              counter
              autofocus
              @input="handleInput(props.item, 'DYNAMIC_BUILDING_ENVELOPE')"
              type="number"
              :readonly="
                ['ENERGY_FLEXIBILITY_AND_STORAGE'].includes(props.item.name)
              "
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.ELECTRIC_VEHICLE_CHARGING="props">
        <v-edit-dialog
          :return-value.sync="props.item.ELECTRIC_VEHICLE_CHARGING"
          large
          persistent
        >
          <div
            :class="{
              'zero-weights': [
                'COMFORT',
                'ENERGY_EFFICIENCY',
                'MAINTENANCE_AND_FAULT_PREDICTION',
                'HEALTH_WELL_BEING_AND_ACCESSIBILITY',
              ].includes(props.item.name),
            }"
          >
            {{ props.item.ELECTRIC_VEHICLE_CHARGING }}
          </div>
          <template v-slot:input>
            <v-text-field
              v-model="props.item.ELECTRIC_VEHICLE_CHARGING"
              :rules="[range]"
              label="Edit"
              single-line
              counter
              autofocus
              @input="handleInput(props.item, 'ELECTRIC_VEHICLE_CHARGING')"
              type="number"
              :readonly="
                [
                  'COMFORT',
                  'ENERGY_EFFICIENCY',
                  'MAINTENANCE_AND_FAULT_PREDICTION',
                  'HEALTH_WELL_BEING_AND_ACCESSIBILITY',
                ].includes(props.item.name)
              "
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.MONITORING_AND_CONTROL="props">
        <v-edit-dialog
          :return-value.sync="props.item.MONITORING_AND_CONTROL"
          large
          persistent
        >
          <div
            :class="{
              'zero-weights': [
                'COMFORT',
                'HEALTH_WELL_BEING_AND_ACCESSIBILITY',
              ].includes(props.item.name),
            }"
          >
            {{ props.item.MONITORING_AND_CONTROL }}
          </div>
          <template v-slot:input>
            <v-text-field
              v-model="props.item.MONITORING_AND_CONTROL"
              :rules="[range]"
              label="Edit"
              single-line
              counter
              autofocus
              @input="handleInput(props.item, 'MONITORING_AND_CONTROL')"
              type="number"
              :readonly="
                ['COMFORT', 'HEALTH_WELL_BEING_AND_ACCESSIBILITY'].includes(
                  props.item.name
                )
              "
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
    </v-data-table>

    <v-row>
      <v-col>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-icon color="primary" v-on="on">mdi-information</v-icon>
          </template>
          <span
            >Each cell is editable and accepts values between 0 and 1<br />
            The sum of all impact values in overall column must be exactly 1
            <br />
            The sum of all domain values within one impact row must be exactly
            1</span
          >
        </v-tooltip>
      </v-col>

      <v-col class="text-center">
        <v-btn @click="saveWeights" width="200px">Save weights</v-btn>
      </v-col>
      <v-col>
        <div
          style="
            width: 15px;
            height: 15px;
            background-color: green;
            display: inline-block;
            margin-right: 10px;
          "
        ></div>
        <span>domain has no influence on the specific impact</span>
      </v-col>
    </v-row>

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snack = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import services from "../rest/Services";

export default {
  props: {
    funitId: Number,
    weights: Object,
  },
  mounted: function () {
    this.setWeights(this.weights);
  },

  data() {
    return {
      snack: false,
      snackColor: "",
      snackText: "",
      range: (v) => (v >= 0 && v <= 1) || "Weights must be between 0 and 1",
      pagination: {},
      headers: [
        { text: "Impacts", value: "label" },
        { text: "Overall", value: "OVERALL" },
        { text: "Heating", value: "HEATING" },
        { text: "Domestic hot water", value: "DOMESTIC_HOT_WATER" },
        { text: "Cooling", value: "COOLING" },
        { text: "Ventilation", value: "VENTILATION" },
        { text: "Lighting", value: "LIGHTING" },
        { text: "Electricity", value: "ELECTRICITY" },
        {
          text: "Dynamic building envelope",
          value: "DYNAMIC_BUILDING_ENVELOPE",
        },
        {
          text: "Electric vehicle charging",
          value: "ELECTRIC_VEHICLE_CHARGING",
        },
        { text: "Monitoring and control", value: "MONITORING_AND_CONTROL" },
      ],
      impacts: [
        {
          name: "ENERGY_EFFICIENCY",
          label: "Energy efficiency",
          OVERALL: 0,
          HEATING: 0,
          DOMESTIC_HOT_WATER: 0,
          COOLING: 0,
          VENTILATION: 0,
          LIGHTING: 0,
          ELECTRICITY: 0,
          DYNAMIC_BUILDING_ENVELOPE: 0,
          ELECTRIC_VEHICLE_CHARGING: 0,
          MONITORING_AND_CONTROL: 0,
        },
        {
          name: "ENERGY_FLEXIBILITY_AND_STORAGE",
          label: "Energy flexibility and storage",
          OVERALL: 0,
          HEATING: 0,
          DOMESTIC_HOT_WATER: 0,
          COOLING: 0,
          VENTILATION: 0,
          LIGHTING: 0,
          ELECTRICITY: 0,
          DYNAMIC_BUILDING_ENVELOPE: 0,
          ELECTRIC_VEHICLE_CHARGING: 0,
          MONITORING_AND_CONTROL: 0,
        },
        {
          name: "COMFORT",
          label: "Comfort",
          OVERALL: 0,
          HEATING: 0,
          DOMESTIC_HOT_WATER: 0,
          COOLING: 0,
          VENTILATION: 0,
          LIGHTING: 0,
          ELECTRICITY: 0,
          DYNAMIC_BUILDING_ENVELOPE: 0,
          ELECTRIC_VEHICLE_CHARGING: 0,
          MONITORING_AND_CONTROL: 0,
        },
        {
          name: "CONVENIENCE",
          label: "Convenience",
          OVERALL: 0,
          HEATING: 0,
          DOMESTIC_HOT_WATER: 0,
          COOLING: 0,
          VENTILATION: 0,
          LIGHTING: 0,
          ELECTRICITY: 0,
          DYNAMIC_BUILDING_ENVELOPE: 0,
          ELECTRIC_VEHICLE_CHARGING: 0,
          MONITORING_AND_CONTROL: 0,
        },
        {
          name: "HEALTH_WELL_BEING_AND_ACCESSIBILITY",
          label: "Health, well being and accessibility",
          OVERALL: 0,
          HEATING: 0,
          DOMESTIC_HOT_WATER: 0,
          COOLING: 0,
          VENTILATION: 0,
          LIGHTING: 0,
          ELECTRICITY: 0,
          DYNAMIC_BUILDING_ENVELOPE: 0,
          ELECTRIC_VEHICLE_CHARGING: 0,
          MONITORING_AND_CONTROL: 0,
        },
        {
          name: "MAINTENANCE_AND_FAULT_PREDICTION",
          label: "Maintenance and fault prediction",
          OVERALL: 0,
          HEATING: 0,
          DOMESTIC_HOT_WATER: 0,
          COOLING: 0,
          VENTILATION: 0,
          LIGHTING: 0.0,
          ELECTRICITY: 0,
          DYNAMIC_BUILDING_ENVELOPE: 0,
          ELECTRIC_VEHICLE_CHARGING: 0,
          MONITORING_AND_CONTROL: 0,
        },
        {
          name: "INFORMATION_TO_OCCUPANTS",
          label: "Information to occupants",
          OVERALL: 0,
          HEATING: 0,
          DOMESTIC_HOT_WATER: 0,
          COOLING: 0,
          VENTILATION: 0,
          LIGHTING: 0,
          ELECTRICITY: 0,
          DYNAMIC_BUILDING_ENVELOPE: 0,
          ELECTRIC_VEHICLE_CHARGING: 0,
          MONITORING_AND_CONTROL: 0,
        },
      ],
    };
  },
  methods: {
    setWeights: function (data) {
      if (data.user_defined_impact_weights) {
        this.setImpactWeights(data.user_defined_impact_weights);
        this.setDomainWeights(data.user_defined_domain_weights);
      }
    },
    setImpactWeights: function (response) {
      this.impacts.forEach((impact) => {
        impact.OVERALL = response[impact.name];
      });
      console.log("this.impacts :>> ", this.impacts);
    },
    setDomainWeights: function (response) {
      for (const impact in response) {
        let tableImpact = this.impacts.find(
          (tableImpact) => tableImpact.name === impact
        );
        for (const domain in response[impact]) {
          tableImpact[domain] = response[impact][domain];
        }
      }
    },
    handleInput(item, prop) {
      if (item[prop] < 0 || item[prop] > 1) {
        item[prop] = 0;
      } else item[prop] = parseFloat(item[prop]);
    },
    checkImpactWeightsSum: function () {
      let checkSum = 0;
      for (let i = 0; i < this.impacts.length; i++) {
        checkSum += parseFloat(this.impacts[i].OVERALL);
      }
      if (Math.abs(checkSum - 1) < 0.0001) return true;
      else {
        this.$emit("impactWeightsSumError", checkSum);
        return false;
      }
    },
    checkDomainWeightsSum: function (data) {
      for (const impactKey in data) {
        const impact = data[impactKey];
        const sum = Object.values(impact).reduce(
          (acc, value) => acc + value,
          0
        );

        if (Math.abs(sum - 1) > 0.0001) {
          const impactLabel = this.impacts.find(
            (impact) => impact.name === impactKey
          ).label;
          this.$emit("domainWeightsSumError", impactLabel, sum);
          return false;
        }
      }
      return true;
    },
    saveWeights: function () {
      if (!this.checkImpactWeightsSum()) return;
      let impact_weights = {};
      this.impacts.forEach(
        (impact) => (impact_weights[impact.name] = impact.OVERALL)
      );
      const impactWeightsParams = {
        impact_weights,
        functional_unit_id: this.funitId,
      };
      let domain_weights = {};
      this.impacts.forEach((impact) => (domain_weights[impact.name] = impact));

      //remove name, label and OVERALL properties
      const modifiedImpacts = Object.entries(domain_weights).reduce(
        (acc, [key, value]) => {
          // eslint-disable-next-line no-unused-vars
          const { name, label, OVERALL, ...rest } = value;
          acc[key] = rest;
          return acc;
        },
        {}
      );
      if (!this.checkDomainWeightsSum(modifiedImpacts)) return;

      const domainWeightsParams = {
        domain_weights: modifiedImpacts,
        functional_unit_id: this.funitId,
      };
      const impactWeightsPromise =
        services.saveImpactWeights(impactWeightsParams);
      const domainWeightsPromise =
        services.saveDomainWeights(domainWeightsParams);

      Promise.all([impactWeightsPromise, domainWeightsPromise])
        .then((response) => {
          console.log("response :>> ", response);
          this.$emit("saveWeightsSuccess");
        })
        .catch((error) => {
          if (error.response.status === 409) {
            this.$emit("weightsAlreadyExists");
          }
        });
    },
    resetWeights() {
      this.impacts.forEach((impact) => {
        for (const prop in impact) {
          if (!["name", "label"].includes(prop)) impact[prop] = 0;
        }
      });
    },
  },
  watch: {
    weights: function (value) {
      this.resetWeights();
      this.setWeights(value);
    },
  },
};
</script>

<style scoped>
.orange-column .v-data-table__overflow {
  background-color: orange;
}
.zero-weights {
  background-color: green;
  padding: 2px 6px;
  color: white;
}
</style>
